import { connect } from "react-redux";
import AgentDetailPage from "../../components/AgentDetailPage/AgentDetailPage";
import {
  profile,
  farProfile,
  feedback,
  recommendation,
  hestiaInformation,
  socialUpdates,
  fetchCheckins,
  clickDetectorAndScroll,
  shareProfileSuccess,
} from "../../store/actions/profile.action";
import {
  SHARE_MODAL,
  showModal,
  REVIEW_MODAL,
  RECOMMENDATION_MODAL,
  ASK_A_QUESTION,
} from "../../store/actions/modal.action";
import { askAQuestion } from "../../store/actions/askaquestion.action";
import {
  setRecommendationSuccess,
  setAskAQuestionSuccess,
  setReviewSuccess,
} from "../../store/actions/individualagent.action";
const mapDispatchToProps = (dispatch) => {
  return {
    profile: (advertiser_id, nrds_id) => {
      dispatch(profile(advertiser_id, nrds_id));
    },
    socialUpdates: (profileData) => {
      dispatch(socialUpdates(profileData));
    },
    fetchCheckins: (advertiser_id, nrds_id) => {
      dispatch(fetchCheckins(advertiser_id, nrds_id));
    },
    farProfile: (advertiser_id, type) => {
      dispatch(farProfile(advertiser_id, type));
    },
    feedback: (advertiser_id) => {
      dispatch(feedback(advertiser_id));
    },
    hestiaInformation: (advertiser_id, agents, page, type) => {
      dispatch(hestiaInformation(advertiser_id, agents, page, type, "AgentDetailContainer"));
    },
    recommendation: (advertiser_id) => {
      dispatch(recommendation(advertiser_id));
    },
    showShareModal: (agentdetail) => {
      dispatch(showModal(SHARE_MODAL, agentdetail));
    },
    showRecommendationModal: (agentdetail) => {
      dispatch(showModal(RECOMMENDATION_MODAL, agentdetail));
    },
    ask_a_question_modal: (agentdetail) => {
      dispatch(showModal(ASK_A_QUESTION, agentdetail));
    },
    showReviewModal: (agentdetail) => {
      dispatch(showModal(REVIEW_MODAL, agentdetail));
    },
    askAQuestion: (data) => {
      dispatch(askAQuestion(data));
    },
    setRecommendationSuccess: (data) => {
      dispatch(setRecommendationSuccess(data));
    },
    setReviewSuccess: (data) => {
      dispatch(setReviewSuccess(data));
    },

    setAskAQuestionSuccess: (data) => {
      dispatch(setAskAQuestionSuccess(data));
    },
    clickDetectorAndScroll: (data) => {
      dispatch(clickDetectorAndScroll(data));
    },
    shareProfileSuccess: (data) => {
      dispatch(shareProfileSuccess(data));
    },
  };
};
const mapStateToProps = (state) => {
  return {
    agentdetail: state.profile.agentdetail,
    profileData: state.profile.profileData,
    feedbackData: state.profile.feedbackData,
    profileloading: state.profile.profileloading,
    farprofileloading: state.profile.farprofileloading,
    hestiaData: state.profile.hestiaData,
    recommendationData: state.profile.recommendationData,
    socialUpdateData: state.profile.socialUpdateData,
    fetchCheckinsData: state.profile.fetchCheckinsData,
    askaquestion: state.askaquestion.status,
    reviewRatingResponse: state.profile.reviewRatingResponse,
    recommendationLoading: state.profile.recommendationPostloading,
    recommendationSuccess: state.individualagent.recommendationSuccessStatus,
    reviewSuccess: state.individualagent.reviewSuccessStatus,
    askaQuestionSuccess: state.individualagent.askAQuestionSuccessStatus,
    shareStatus: state.profile.shareProfileResponse,
    pageLoading: state.profile.loading,
    clickDetectorData: state.profile.clickDetectorData,
    socialloading: state.profile.socialloading,
  };
};

const AgentDetailContainer = connect(mapStateToProps, mapDispatchToProps)(AgentDetailPage);
export default AgentDetailContainer;
